import React from 'react';
import { SketchPicker } from 'react-color';
import { ITheme } from './themeType';

interface ColorPickerItemProps {
  type: keyof ITheme;
  color?: string;
  open: boolean;
  onClick: () => void;
  onChange: (hex: string, type: keyof ITheme) => void;
}

const ColorPickerItem: React.FC<ColorPickerItemProps> = ({ type, color, open, onClick, onChange }) => {
  return (
    <div>
      <div
        className="flex items-center justify-between px-2 py-1 cursor-pointer hover:bg-gray-100 rounded"
        onClick={onClick}
      >
        <span className="font-medium capitalize text-sm">{type}</span>
        <div className="w-5 h-5 rounded border" style={{ backgroundColor: color ?? '#ffffff' }} />
      </div>

      {open && (
        <div className="mt-2">
          <SketchPicker
            color={color ?? '#ffffff'}
            onChangeComplete={(color) => onChange(color.hex, type)}
          />
        </div>
      )}
    </div>
  );
};

export default ColorPickerItem;
